import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';
import { helpModalIndex } from '../modals/helpModalIndex';

export const FieldHelpIcon = ({ handleClick, tooltipLabel }) => {
  let modalConfig = 'Field Info';
  const tooltip = helpModalIndex[tooltipLabel];
  if (tooltip !== undefined) {
    if (tooltip.title !== undefined) {
      modalConfig = `${tooltip.title}`;
    }
  }
  return (
    <IconWithTooltip
      handleClick={handleClick}
      ariaLabel={modalConfig}
      tooltip={modalConfig}
      icon="question-circle"
    />
  );
};


FieldHelpIcon.propTypes = {
  // eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
  tooltipLabel: PropTypes.string,
};

FieldHelpIcon.defaultProps = {
  tooltipLabel: 'Field Info',
};
